import React, { useRef, useEffect } from "react";
import {
    Avatar,
    AvatarSvg,
    CategoryTitle,
    Info,
    Name,
    ResultGroup,
    ResultItem,
    ResultsList,
    ResultText,
    SearchContainer,
} from "./ExtensionSearch";
import { toAbsoluteUrl } from "_metronic/_helpers";
import styled from "styled-components";
import { colors } from "app/popleads/components/ui-kit/colors";

const StyledResultsList = styled(ResultsList)`
    position: absolute;
    top: 0;
    width: 100%;
    // left: 12px;
`;
const StyledCategoryTitle = styled(CategoryTitle)`
    font-size: 14px;
    color: ${colors.neutral[700]};
    font-weight: 500;
`;
const StyledResultItem = styled(ResultItem)`
    cursor: pointer;
`;

const Highlighted = styled.span`
    letter-spacing: -0.17px;
    color: #0085be;
    font-weight: 500;
`;

const ExtensionFullSizeDropdown = ({
    handleResultClick,
    setIsOpen,
    isOpen,
    options,
    searchText,
    title,
    footerComponent,
}) => {
    const dropdownRef = useRef(null);

    const highlightText = (text, search) => {
        if (!search) return text;
        const regex = new RegExp(`(${search})`, "gi");
        const parts = text?.split(regex);

        return parts?.map((part, index) => (regex.test(part) ? <Highlighted key={index}>{part}</Highlighted> : part));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setIsOpen]);

    return (
        <SearchContainer ref={dropdownRef}>
            <StyledResultsList isOpen={isOpen}>
                <ResultGroup>
                    <StyledCategoryTitle>{title}</StyledCategoryTitle>
                    {options.map((result, index) => (
                        <StyledResultItem key={index} onClick={() => handleResultClick(result)}>
                            {result.resim ? (
                                <Avatar src={result.resim} alt={result.ad} />
                            ) : (
                                <AvatarSvg src={toAbsoluteUrl("/media/svg/icons/Extension/user-avatar.svg")} />
                            )}
                            <ResultText>
                                <Name>{highlightText(`${result.ad} ${result.soyad}`, searchText)}</Name>
                                <Info>
                                    {result.sirket && result.sirket}
                                    {result.sirket && result.sektor && " | "}
                                    {result.sektor && result.sektor}
                                </Info>
                            </ResultText>
                        </StyledResultItem>
                    ))}
                    {footerComponent}
                </ResultGroup>
            </StyledResultsList>
        </SearchContainer>
    );
};

export default ExtensionFullSizeDropdown;
